module.exports = __webpack_public_path__ + "static/img/lxwm-bg@2x.ef7093e8.png";